import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as Plus } from 'Images/icon-action-bar-plus.svg';

export const Wrapper = styled.div`
  width: 497px;
  margin-bottom: 15px;
  /* position: relative; */
`;

Wrapper.displayName = 'SearchListWrapper';

export const PlusIcon = styled(Plus)`
  position: absolute;
  right: 10px;
  top: 13px;
  width: 10px;
  & > path {
    fill: ${colors.blueGrey};
  }
`;

PlusIcon.displayName = 'PlusIcon';

export const dropdownStyle = (theme) => ({
  control: (provided) => ({
    display: 'flex',
    minHeight: '35px',
    boxShadow: '2px 2px 5px 0 rgba(0, 0, 0, 0.06), inset 0 -1px 0 0 #afafaf',
    backgroundColor: theme.textfield.background2,
    borderBottomWidth: '0px',
    color: theme.textfield.text,
    paddingLeft: '10px',
    fontWeight: '700',
    textOverflow: 'ellipsis',
    borderLeft: '12px solid #53a9ff',
    cursor: 'pointer'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '12.5px',
    color: theme.text.placeholder,
    fontWeight: 400
  }),
  input: (provided) => ({
    ...provided,
    fontSize: '13px',
    color: theme.textfield.text,
    fontWeight: 300
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: theme.text.actionDropDown,
    width: '30px'
  }),
  option: (provided, { isFocused, data }) => ({
    ...provided,
    backgroundColor: isFocused ? theme.backgrounds.modal2 : theme.backgrounds.actionDropDown,
    fontSize: '13.5px',
    textAlign: 'left',
    color: theme.buttons.custom.color,
    cursor: isFocused ? 'pointer' : 'default',
    paddingLeft: '22px',
    paddingRight: '22px',
    height: '36px',
    textTransform: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }),
  valueContainer: () => ({
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    marginRight: 'auto'
  }),
  menu: () => ({
    position: 'absolute',
    marginTop: '6px',
    zIndex: 5000,
    width: '100%',
    border: 'none',
    borderRadius: '3px',
    backgroundColor: theme.backgrounds.actionDropDown,
    boxShadow: `2px 2px 30px 0 #d5dee6 ${theme.shadows.actionDropDown}`,
    minWidth: '190px'
  }),
  menuList: () => ({
    maxHeight: '152px',
    overflowX: 'auto',
    borderRadius: '3px',
    paddingTop: '10px',
    paddingBottom: '13px'
  }),
  singleValue: (provided, state) => {
    const transition = 'opacity 300ms';
    return {
      ...provided, transition, color: theme.textfield.text, width: 'fit-content', height: '19px', fontSize: '14px', fontWeight: 400, top: '8px', position: 'relative'
    };
  }
});
